import get from 'lodash.get';
import { emptyObject } from '../../../default-props/empty';

export const selectExportOrdersJobByJobId = (state, { jobId }) => {
  const jobIdToJobMap = get(state, 'jobIdToJobMap', emptyObject);
  return jobIdToJobMap[jobId];
};
